
var cmsThemes = new Map<string, ITheme>([
  [
    "template",
   {
     headerColor: "headerColor",
     headerTextColor: "headerTextColor",
     loaderColor: "loaderColor",
     infoMessageColor: "primary",
     backgroundColor: "backgroundColor",

     buttonColor: "buttonColor",
     buttonTextColor: "buttonTextColor",
     buttonBorderColor:"buttonBorderColor",
     buttonSecondaryColor: "buttonSecondaryColor",
     buttonSecondaryTextColor: "buttonSecondaryTextColor",
     buttonSecondaryBorderColor: "buttonSecondaryBorderColor",

     meetingCardActiveColor: "meetingCardActiveColor",
     meetingCardActiveButtonColor: "meetingCardActiveButtonColor",
     meetingCardActiveButtonTextColor: "meetingCardActiveButtonTextColor",
     meetingCardActiveTextColor:"meetingCardActiveTextColor",
     meetingCardActiveBorderColor:"meetingCardActiveBorderColor",
     
     meetingCardPastColor: "meetingCardPastColor",
     meetingCardPastTextColor:"meetingCardPastTextColor",
     meetingCardPastBorderColor:"meetingCardPastBorderColor",
     meetingCardPastButtonColor:"meetingCardPastButtonColor",
     meetingCardPastButtonTextColor:"meetingCardPastButtonTextColor",
     
     meetingCardFutureColor: "meetingCardFutureColor",
     meetingCardFutureBorderColor: "meetingCardFutureBorderColor",
     meetingCardFutureTextColor:"meetingCardFutureTextColor",
     meetingCardFutureButtonColor:"meetingCardFutureButtonColor",
     meetingCardFutureButtonTextColor:"meetingCardFutureButtonTextColor",

     meetingCardOfflineColor: "meetingCardOfflineColor",
     meetingCardOfflineTextColor:"meetingCardOfflineTextColor",
     meetingCardOfflineBorderColor:"meetingCardOfflineBorderColor",
     meetingCardOfflineButtonColor:"meetingCardOfflineButtonColor",
     meetingCardOfflineButtonTextColor:"meetingCardOfflineButtonTextColor",

     saveOfflineMeetingButtonActive: "meetingCardFutureColor",
     saveOfflineMeetingButtonPast: "saveOfflineMeetingButtonPast",
     saveOfflineMeetingButtonFuture: "saveOfflineMeetingButtonFuture",
           
     titleBarBgOdg: "titleBarBgOdg",
     titleBarTextOdg: "titleBarTextOdg",
     titleBarBgDocument: "titleBarBgDocument",
     titleBarTextDocument: "titleBarTextDocument",
     titleBarBgSurvey: "titleBarBgSurvey",
     titleBarTextSurvey: "titleBarTextSurvey",

     headerModal:"headerModal",
     colorTextDateOdg:"colorTextDateOdg",

     currentMeetingTextColor: "currentMeetingTextColor",
     currentMeetingIconColor: "currentMeetingIconColor",  

     sidebarColor: "sidebarColor",
     sidebarBorder: "sidebarBorder",
     sidebarSelectedButton: "sidebarSelectedButton",
     sidebarBurgherButton: "sidebarBurgherButton",
     
     yearSelectionBarColor:  "yearSelectionBarColor",
     yearSelectedColor: "yearSelectedColor",
     yearColor: "yearColor",


     toolbarBackground: "toolbarBackground",
     toolbarSelectedTabText: "toolbarSelectedTabText",
     toolbarSelectedTabBackground:"toolbarSelectedTabBackground",
     toolbarIconColor: "toolbarIconColor",      
     toolbarActiveIconColor: "toolbarActiveIconColor",  
     toolbarShareActiveColor: "toolbarShareActiveColor",        //colore icona bottone condividi quanto è attivo
     toolbarShareActiveBackground: "toolbarShareActiveBackground",   //colore sfondo bottone condividi quanto è attivo
   },
 ]
  
]);

export interface ITheme {
  headerColor: string;        //colore header pagina
  headerTextColor: string;    //colore testo header pagina
  loaderColor: string;
  infoMessageColor: string;

  buttonColor: string;                 //colore Bottoni generali
  buttonTextColor?:string;             //colore testo bottoni generali
  buttonBorderColor?:string;          //bordo bottoni generali

  buttonSecondaryColor?: string;      //colore secondario bottoni
  buttonSecondaryTextColor?: string;   //colore testo bottone secondario
  buttonSecondaryBorderColor?: string

  backgroundColor: string;      //colore background 

  sidebarColor?: string;               //background della sidebar
  sidebarBorder?:string;               //colora i border della sidebar ed i bottoni della sidebar
  sidebarSelectedButton?: string;       //Colore bottone sidebar selezionato
  sidebarBurgherButton?:string;         //colore burgher Sidebar

  meetingCardActiveColor?: string;            //colore meeting card attiva
  meetingCardActiveTextColor?: string;        //testo
  meetingCardActiveBorderColor?: string;      //bordo
  meetingCardActiveButtonColor?:string;       //bottone
  meetingCardActiveButtonTextColor?:string;   //bordo bottone

  currentMeetingTextColor?: string;           //colore testo "in corso" del meeting corrente
  currentMeetingIconColor?: string;           //colore iconna meeting corrente

  meetingCardPastColor?: string;           //colore meeting card passata
  meetingCardPastTextColor?: string;       //testo
  meetingCardPastBorderColor?: string;     //bordo
  meetingCardPastButtonColor?:string;      //bottone
  meetingCardPastButtonTextColor?:string;   //bordo bottone

  meetingCardFutureColor?: string;          //colore meeting card futura
  meetingCardFutureTextColor?: string;      //testo
  meetingCardFutureBorderColor?: string;    //bordo
  meetingCardFutureButtonColor?:string;     //bottone
  meetingCardFutureButtonTextColor?:string; //bordo bottone

  meetingCardOfflineColor?: string;          //colore meeting card Offline
  meetingCardOfflineTextColor?: string;      //testo
  meetingCardOfflineBorderColor?: string;    //bordo
  meetingCardOfflineButtonColor?:string;     //bottone
  meetingCardOfflineButtonTextColor?:string; //bordo bottone

  saveOfflineMeetingButtonActive?:string;       //bottone salvataggio meeting offline card attiva
  saveOfflineMeetingButtonPast?: string;        //bottone salvataggio meeting offline card passata
  saveOfflineMeetingButtonFuture?: string;      //bottone salvataggio meeting offline card futura


  titleBarTextOdg?: string;        //testo
  titleBarBgOdg?: string;         //colore della barra con titolo meeting nella pagina Ordine del giorno

  titleBarBgDocument?: string;    // colore della barra con titolo documento nella pagina di visualizzazione documento
  titleBarTextDocument?: string;  //testo

  titleBarBgSurvey?: string;      //colore della barra con titolo sondaggio
  titleBarTextSurvey?: string;    //testo

  headerModal?: string;           // colore dell'header dei modali
  colorTextDateOdg? :string       // colore della data del meeting per la pagina Ordine del giorno

  yearSelectionBarColor?: string;   //colore toolbar selezione anno(dei meeting)
  yearSelectedColor?: string;       //colore anno selezionato
  yearColor?: string;               //colore anni non selezionati
  
  toolbarBackground?:string;                 //colore sfondo toolbar
  toolbarSelectedTabText?: string;          //colore testo tab selezionata
  toolbarSelectedTabBackground?:string;     //colore sfondo tab selezionata
  toolbarIconColor?:string;                 //colore icone
  toolbarActiveIconColor?:string;           //colore icona bottone attivo
  toolbarShareActiveColor?: string;         //colore icona bottone condividi quanto è attivo
  toolbarShareActiveBackground?: string;    //colore sfondo bottone condividi quanto è attivo
}

export default cmsThemes;

export interface ICompanyTheme {
  displayTenantNameInTenantList: boolean; //mostrare il nome del tenant nella pagina selezione tenant
  sidebarButtonBorder?: "none" | "rounded" | "squared";
  oldToolbar: boolean;
  hiddenEndHour: boolean;
  hiddenEndDate:boolean;
  hiddenStartDate:boolean;
  hiddenStartHour:boolean;
  hiddenDuration:boolean;
  hiddenNumDoc:boolean;
};
